// Field specs mirror the wording of the uploaded originals (Form 3A, NOC, Statement of Case).
// letterTemplate is the print/PDF layout: pure text with {placeholders} that get filled in-line;
// missing values render as underscored blanks so the form works both blank and pre-filled.
export const formSpecs = {
  "GI-3A": {
    title: "Form GI 3A",
    subtitle: "Application for the Registration of an Authorized User",
    header: [
      "Geographical Indications of Goods (Registration & Protection) Act, 1999",
      "Geographical Indications of Goods (Registration & Protection) Rules, 2002",
    ],
    reference: "[Section 17 (1), Rule 56 (1)]  ·  Fee: Rs.10  ·  [See entry No.3A of the First Schedule]",
    fields: [
      { name: "applicant_name", label: "1. Name of the Applicant (proposed Authorized user)" },
      { name: "applicant_address", label: "2. Address of the applicant", type: "textarea" },
      { name: "service_address", label: "3. Address of service (if different from above)", type: "textarea" },
      { name: "registered_gi", label: "4. Registered Geographical Indication for which application is made" },
      { name: "email", label: "5. Email id", type: "email" },
      { name: "phone", label: "6. Phone / mobile number" },
      { name: "proprietor_name", label: "Name of the registered proprietor (for the declaration)" },
    ],
    letterHeadLines: [
      "Geographical Indications of Goods (Registration & Protection) Act, 1999",
      "Geographical Indications of Goods (Registration & Protection) Rules, 2002",
    ],
    letterTitle: "Form GI 3A",
    letterSubtitle: "Application for the Registration of an Authorized User",
    letterMeta: [
      "[Section 17 (1), Rule 56 (1)]",
      "Fee: Rs.10",
      "[See entry No.3A of the First Schedule]",
    ],
    letterBody: [
      "(1) Name of the Applicant (proposed Authorized user): {applicant_name}",
      "(2) Address of the applicant: {applicant_address}",
      "(3) Address of service (if different from above): {service_address}",
      "(4) Registered Geographical Indication for which application is made: {registered_gi}",
      "(5) Email id: {email}",
      "(6) Phone/mobile number: {phone}",
      "",
      "Declaration:",
      "(1) I hereby declare that I have enclosed the statement of case and evidence of due service of copy of my application to the registered proprietor ({proprietor_name}) for {registered_gi}, registered as a Geographical Indication.",
      "(2) I also declare that all the above information is true and correct to the best of my knowledge and belief.",
      "(3) I undertake that if any of the information is found incorrect or false, my application may be rejected and if already accepted, my registration may be revoked and my name removed from Part B of the register.",
    ],
    letterFooter: {
      leftPairs: [["Date:", "{signature_date}"], ["Place:", "{signature_place}"]],
      rightLabel: "SIGNATURE",
    },
  },

  "Statement-of-Case": {
    title: "Statement of Case",
    subtitle: "STATEMENT OF CASE FOR REGISTRATION OF AUTHORISED USER",
    header: [
      "Geographical Indications of Goods (Registration & Protection) Act, 1999",
      "Geographical Indications of Goods (Registration & Protection) Rules, 2002",
    ],
    reference: "Statement of Case enclosed with Form GI 3A",
    fields: [
      { name: "artisan_name", label: "I, (Name of Artisan / Producer)" },
      { name: "artisan_age", label: "Aged about (years)" },
      { name: "parent_name", label: "S/o or D/o" },
      { name: "residing_address", label: "Residing at (complete address)", type: "textarea" },
      { name: "state", label: "State", placeholder: "e.g., Karnataka, India" },
      { name: "gi_name", label: "Name of GI (used across the statement)" },
      { name: "apply_for_purpose", label: "Purpose of authorised user registration", type: "textarea" },
      { name: "since_year", label: "Since year (production started)" },
      { name: "years_experience", label: "For how many years" },
      { name: "area_name", label: "In area" },
      { name: "annual_amount", label: "Approximate annual earnings (Rs.)" },
      { name: "annual_words", label: "Rs. in words (only)" },
      { name: "artisan_card_authority", label: "Artisan Card issued by" },
      { name: "aadhar_number", label: "Aadhaar card details" },
    ],
    letterTitle: "STATEMENT OF CASE FOR REGISTRATION OF AUTHORISED USER",
    letterBody: [
      "I, {artisan_name}, aged about {artisan_age} years, S/o or D/o {parent_name}, residing at {residing_address} (Address), {state}, declare as follows:",
      "",
      "1. That, I am a producer of {gi_name} (Name of GI).",
      "",
      "2. I am aware of Geographical Indication Registration to {gi_name} (Name of GI) and hereby apply for registration as an \"Authorised User\" for {apply_for_purpose}.",
      "",
      "3. I am involved in the process of production of {gi_name} (Name of GI) since year {since_year} ({years_experience} Years) in {area_name} (Area name).",
      "",
      "4. The annual earnings from production of {gi_name} (Name of GI) is approximately Rs. {annual_amount} (Rs. {annual_words} only).",
      "",
      "5. I am supported and recognized by the following statutory body / bodies (Copy enclosed):",
      "   1. Artisan Card issued by: {artisan_card_authority}",
      "   2. Aadhar card details: {aadhar_number}",
      "",
      "6. Further, I hereby declare that I am aware and shall adhere and confirm to all the quality parameters (present and future) relating to production of {gi_name} (Name of GI).",
      "",
      "I reiterate that the particulars set out herein are true to the best of my knowledge, information and belief.",
    ],
    letterFooter: {
      leftPairs: [["Dated:", "{signature_date}"], ["Place:", "{signature_place}"]],
      rightLabel: "(Signature and Name of Artisan/Producer)",
    },
  },

  "NOC": {
    title: "No Objection Certificate",
    subtitle: "TO WHOMSOEVER IT MAY CONCERN",
    header: [
      "Geographical Indications of Goods (Registration & Protection) Act, 1999",
    ],
    reference: "To be printed on the letterhead of the Registered Proprietor. Producer name, GI item and application number are auto-filled from Statement of Case and GI catalog.",
    fields: [
      { name: "class_number", label: "Class" },
    ],
    letterTitle: "NO OBJECTION CERTIFICATE",
    letterSubtitle: "TO WHOMSOEVER IT MAY CONCERN",
    letterBody: [
      "This is to certify that M/s. / Shri. / Smt. {producer_name} is the Producer of {producer_item}, which is a Registered Geographical Indication, G.I. Application Number: {gi_application} in Class {class_number}. The proposed Authorised user is Producer within the designated GI Area. The Registered proprietor has no objection for Registration as GI Authorised User.",
    ],
    letterFooter: {
      leftPairs: [["Date:", "{signature_date}"], ["Place:", "{signature_place}"]],
      rightLabel: "Signature\nWith Seal",
    },
    letterNote: "Kindly Note: The No Objection Certificate needs to be printed on the Letter Head of the Registered Proprietor and to be duly signed and sealed.",
    letterhead: true,
  },
};

export const featuredUsers = [
  { name: "Kutch Weaves Collective", place: "Kutch, Gujarat", gi: "Kutch Embroidery", initials: "KW", color: "#d58b4d" },
  { name: "Mysore Silk Atelier", place: "Mysuru, Karnataka", gi: "Mysore Silk", initials: "MS", color: "#39728a" },
  { name: "Banarasi Heritage House", place: "Varanasi, Uttar Pradesh", gi: "Banaras Brocades", initials: "BH", color: "#8b4c39" },
  { name: "Kashmir Craft Circle", place: "Srinagar, Kashmir", gi: "Kashmir Pashmina", initials: "KC", color: "#73916a" },
  { name: "Nashik Artisan Foods", place: "Nashik, Maharashtra", gi: "Nashik Valley Grapes", initials: "NA", color: "#bd723d" },
];

export const sellerNav = [
  { to: "/", label: "Overview" },
  { to: "/profile", label: "My GI profile" },
  { to: "/marketplace", label: "Marketplace" },
  { to: "/documents", label: "Apply for GI Authorised User" },
  { to: "/orders", label: "My orders" },
  { to: "/quotes", label: "Buyer requests" },
  { to: "/verify", label: "Authenticity QR" },
];

export const adminNav = [
  { to: "/admin", label: "Admin overview" },
  { to: "/admin/sellers", label: "Sellers" },
  { to: "/admin/authorised-users", label: "Authorised users" },
  { to: "/admin/orders", label: "Orders" },
  { to: "/admin/submissions", label: "Submissions" },
  { to: "/admin/gi-items", label: "GI catalog" },
  { to: "/admin/contact", label: "Contact messages" },
  { to: "/admin/categories", label: "Categories" },
  { to: "/admin/notifications", label: "Notifications" },
  { to: "/admin/banners", label: "Banners" },
  { to: "/admin/ads", label: "Home ad" },
  { to: "/admin/gallery", label: "Gallery" },
  { to: "/admin/counters", label: "Counters" },
  { to: "/admin/about", label: "About us" },
  { to: "/admin/contact-info", label: "Contact info" },
  { to: "/admin/featured-makers", label: "Meet the makers" },
  { to: "/admin/return-policy", label: "Return policy" },
  { to: "/admin/fees", label: "Fees" },
  { to: "/admin/otp", label: "OTP / Twilio" },
];

export const buyerNav = [
  { to: "/orders", label: "My orders" },
];
